import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '@styles/theme';

const FooterContainer = styled.footer`
  background-color: ${theme.colors.surface.subtle};
  border-top: 1px solid ${theme.colors.border.light};
  margin-top: ${theme.spacing['3xl']};
  padding: ${theme.spacing['2xl']} 0 ${theme.spacing.xl};
`;

const FooterContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 ${theme.spacing.lg};
`;

const FooterBottom = styled.div`
  padding-top: ${theme.spacing.xl};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.spacing.md};

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: ${theme.colors.text.tertiary};
  font-size: ${theme.typography.fontSize.sm};
  margin: 0;
`;



export const Footer: React.FC = () => {
  const { t } = useTranslation('layout');
  return (
    <FooterContainer>
      <FooterContent>
        <FooterBottom>
          <Copyright>{t('footer.copyright')}</Copyright>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

